import { Component } from '@angular/core';
import {MatButton} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {PageHeaderComponent} from '../../../../shared/components/page-templates/page-header/page-header.component';
import {PageFooterComponent} from '../../../../shared/components/page-templates/page-footer/page-footer.component';

@Component({
  selector: 'tgrid-help-landing',
  standalone: true,
  imports: [
    MatButton,
    RouterLink,
    VulcanIconComponent,
    PageHeaderComponent,
    PageFooterComponent,
  ],
  templateUrl: './help-landing.component.html',
  styleUrl: './help-landing.component.scss',
})
export class HelpLandingComponent {

}
